import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowLeft } from "lucide-react";
import { Logo } from "../components/Logo";
import ar from "../i18n/ar.json";

// Thank You page — Spanish only, located at /thank_you.
export default function ThankYou() {
  const ty = ar.thankYou;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      data-testid="thank-you-page"
      className="relative min-h-screen bg-ink text-white grain flex flex-col"
    >
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8 py-7">
        <Link to="/" data-testid="thankyou-logo-home" aria-label="Litiodata">
          <Logo light />
        </Link>
      </div>

      <div className="relative flex flex-1 items-center justify-center px-5 py-16">
        <div className="pointer-events-none absolute left-1/2 top-1/3 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-terracotta/20 blur-[120px]" />
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="relative max-w-xl text-center"
        >
          <motion.span
            initial={{ scale: 0.6, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto grid h-20 w-20 place-items-center rounded-2xl bg-terracotta text-white shadow-[0_20px_50px_rgba(200,90,50,0.4)]"
          >
            <Check size={40} strokeWidth={3} />
          </motion.span>

          <p className="mt-8 font-mono text-xs uppercase tracking-[0.3em] text-terracotta">
            {ty.badge}
          </p>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">
            {ty.title}
          </h1>
          <p className="mx-auto mt-5 max-w-lg text-base leading-relaxed text-white/70">
            {ty.message}
          </p>
          <p className="mt-3 text-sm text-white/50">{ty.note}</p>

          <Link
            to="/"
            data-testid="thankyou-back-home"
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-ink transition-all duration-300 hover:bg-terracotta hover:text-white hover:-translate-y-0.5"
          >
            <ArrowLeft size={16} />
            {ty.backHome}
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
